import { useCradle } from '@/app/contexts';
import { AppConfig } from '@/core/config';
import { Cradle } from '@/di/Cradle';

export function useConfig(): AppConfig {
  const { config } = useCradle<Cradle>();

  return config;
}
